import React, { useState } from 'react';
import ReportControls from './ReportControls';
import { useSearchParams } from 'react-router-dom';
import { ThemeProvider } from '../../../../../platform/app/src/providers/theme/ThemeProvider';

const ReportModalPage = () => {
    const [searchParams] = useSearchParams();
    const studyId = searchParams.get('studyId');
    const [isOpen, setIsOpen] = useState(true);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [templateContent, setTemplateContent] = useState('');

    if (!studyId) return <p className="p-6 text-center text-[var(--v2-text-muted)] text-lg">Missing Study ID</p>;

    return (
        <ThemeProvider>
            <ReportControls
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                // onSelectTemplate={(name, url, content) => {
                //     setSelectedTemplate({ name, url });
                //     setTemplateContent(content);
                // }}
                template={selectedTemplate?.name}
                templateUrl={selectedTemplate?.url}
                templateContent={templateContent}
                onSaveReport={() => setIsOpen(false)}
                fullWidth={true}
            />
        </ThemeProvider>
    );
};

export default ReportModalPage;
